export const data = {
    experience: [
      {
        title: "AI Engineer (Full-time)",
        location: "Global Walkers (Myanmar) co.,Ldt, Yangon",
        date: '2022 - Present',
      },
      {
        title: "Lead ML Engineer (Volunteer)",
        location: "Omdena, New York",
        date: '2021 - Present',
      },
      {
        title: "Junior Data Scientist (Intern)",
        location: "Zummit infolabs, Bangalore",
        date: '2021 - 2022',
      },
    ],
    education: [
      {
        title: "Higher Secondary",
        subTitle: "ICEC Private High School",
        date: "2015"
      },
      {
        title: "Bachelor of Engineering in Electronics and Communication (Hons)",
        subTitle: "Myanmar Institue of Information Technology(MIIT)",
        date: "2015 - 2023"
      },
    ],
  };